import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

export default function FlujoCajaChart({ data }) {
    return (
        <div style={{ width: "100%", height: 300 }}>
            <h3>Flujo de Caja</h3>
            <ResponsiveContainer>
                <BarChart data={data}>
                    <XAxis dataKey="periodo" />
                    <YAxis />
                    <Tooltip />
                    <Bar dataKey="ingresos" />
                    <Bar dataKey="gastos" />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}